/* jshint esversion: 6 */
/* globals angular, $ */

/**
 * Service class to handle login checks and modal operations.
 * @class
 * @param {Object} $rootScope - Angular's root scope service.
 * @param {Object} $http - Angular's HTTP service.
 * @param {Object} $uibModal - Angular UI Bootstrap's modal service.
 * @param {Object} $interval - Angular's interval service.
 * @param {Object} Restangular - Restangular service for RESTful operations.
 * @param {Object} $location - Angular's location service.
 * @param {Object} NotificationService - Service for handling notifications.
 */
class CheckLoginService {
    constructor($rootScope, $http, $uibModal, $interval, Restangular, $location, NotificationService) {
        // 'ngInject'; // Remove this line if present
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$uibModal = $uibModal;
        this.$interval = $interval;
        this.Restangular = Restangular;
        this.$location = $location;
        this.NotificationService = NotificationService;

        this.loginModalInstance = null;
        this.intervalPromise = null;
        this.httpCall = null;
    }

    /**
     * Controller for the login modal.
     * @param {Object} $scope - Angular's scope for the modal.
     * @param {Object} $rootScope - Angular's root scope service.
     */
    loginModalCtrl($scope, $rootScope) {
        $scope.modal = true;

        $scope.credentials = {
            username: "",
            password: ""
        };

        /**
         * Sends login credentials to the server.
         * @param {Object} credentials - User credentials including username and password.
         * @returns {Promise} - Promise from the HTTP POST request.
         */
        const sendLogin = (credentials) => {
            var httpOptions = {
                timeout: 30000,
                headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}
            };

            return this.$http.post(
                '/authentication/api_login/',
                $.param(credentials),
                httpOptions
            ).then((response) => {
                if (response.data.success) {
                    $scope.$close();
                    this.loginModalInstance = null;
                    this.$rootScope.CMSSession = response.data.session;

                    this.NotificationService.init();
                }
                $scope.loginMessage = response.data.message;
            });
        };

        /**
         * Handles login for the admin UI.
         */
        $scope.loginAdminUI = () => {
            var creds = {
                username: $scope.adminui.invigilator_code,
                password: $scope.adminui.access_code,
                csrfmiddlewaretoken: angular.getCookie('csrftoken')
            };

            var promise = sendLogin(creds);

            promise.then(() => {
                console.log("Getting data for current assessment");
                this.Restangular.all('assessment').getCurrentAssessment().then((response) => {
                    console.log("Got data for current assessment", response);
                    var assessment_id = response.assessment_id;
                    var school_code = response.school_code;

                    if (assessment_id && school_code) {
                        this.$location.path('/admin-ui/assessment/detail/' + assessment_id + '/' + school_code);
                    } else {
                        $scope.message = 'Error. Try Again';
                        this.$rootScope.adminLoadingMessageError = "Error reading assessment data: No school_code/assessment_id found";
                        console.error(this.$rootScope.adminLoadingMessageError);
                    }
                }, (err) => {
                    this.$rootScope.adminLoadingMessageError = "Error reading assessment data ("+err.status+" "+err.statusText+")";
                    console.error("Error reading admin assessment data", err, arguments);
                });
            });
        };

        /**
         * Handles regular user login.
         */
        $scope.login = () => {
            var credentials = {
                username: $scope.credentials.username,
                password: $scope.credentials.password,
                csrfmiddlewaretoken: angular.getCookie('csrftoken')
            };

            sendLogin(credentials);
        };
    }

    /**
     * Opens the login modal if it is not already open.
     */
    openModal() {
        if (!this.loginModalInstance)
            this.loginModalInstance = this.$uibModal.open({
                templateUrl: '/views/ib/cms/StartScreen.html',
                windowClass: 'startscreen-modal',
                backdrop: 'static',
                keyboard: false,
                controller: this.loginModalCtrl.bind(this)
            });
    }

    /**
     * Starts the interval to check login status periodically.
     */
    start() {
        this.loginModalInstance = null;

        this.intervalPromise = this.$interval(() => {
            if (this.$rootScope.CMSSession && !this.httpCall) {
                this.httpCall = this.$http.get('/authentication/login_status/').then((response) => {
                    if (!response.data.login) {
                        this.$rootScope.CMSSession = false;
                        this.openModal();
                    }
                }).finally(() => {
                    this.httpCall = null;
                });
            }
        }, 30000);
    }

    /**
     * Stops the interval checking login status.
     */
    stop() {
        if (this.intervalPromise) {
            this.$interval.cancel(this.intervalPromise);
            this.intervalPromise = null;
        }
    }
}

// Add explicit dependency injection
CheckLoginService.$inject = [
    '$rootScope',
    '$http',
    '$uibModal',
    '$interval',
    'Restangular',
    '$location',
    'NotificationService'
];

export default CheckLoginService;